import { TObject } from "../../../common/TObject";
import { Drawing ,DrawMode, State } from "../Drawing";
import { GoogleFeature } from "./GoogleFeature";
import { FeatureType } from "./Features";


export class Feature extends TObject {
    map: any; //google map
    parent: Drawing;
    color: string = null;
    editmode: boolean = false;
    type: FeatureType = FeatureType.UNKNOWN;
    id: any;
    locationId: string = null;
    readonly: boolean;



    constructor(parent: Drawing, readonly:boolean) {
        super(parent);
        this.setMap(parent.map);
        this.readonly = readonly;

        this.when('click', (e) => {
            if (this.readonly) {
                return false;
            }

            if (this.parent.state == State.Edit) {
                return false;
            }
            var l = this.getLonLat();
            if (l) {
                var locationId = this.getLocationId();
                if (locationId) {
                    
                    var f = this.parent.crmmap.Map.LocationIdClick(locationId,l);
                     return false;
                } 
                //Embeded does not have LngLngClick yet
                if (this.parent.crmmap.Map && this.parent.crmmap.Map.LngLngClick) {
                    let f :any= <any> this.parent.crmmap.Map.LngLngClick(new google.maps.LatLng(l[1], l[0]));
                    if (f) {
                        return f.then((d) => {
                            var locationId = this.getLocationId();
                            this.debug('locationID', this.getLocationId());
                            if (d.locationID && (locationId != d.locationID)) {
                                this.setLocationId(d.locationID);
                                return this.parent.save();
                            }
    
                        })
                    }
                }               
            }

            return false;
        });
    }

    setMap(map) {
        this.map = map;
    }

    editable(editmode) {
        this.editmode = editmode;
    }

    delete() {
        this.map = null;
    }

    getId() {
        return this.id;
    }



    getLocationId() {
        if (this.locationId) {
            return this.locationId;
        }
        return null;
    }

    setLocationId(locationId) {
        if (this.locationId == locationId) {
            return this; //no change;
        }

        this.locationId = locationId;
        this.debug('locationID', this.locationId);

        this.changed();
        return this;
    }

    setColor(color) {
        if (this.getcolor() == color) {
            return this; //no change;
        }
        this.color = color;
        this.changed();
        return this;
    }

    getcolor() {
        return this.color;
    }

    getLonLat() {
        this.debug(this);
        console.error("Feature: NO LAT LNG FOR BASE TYPE");
        //rfc7946#section-3.1.2
        return null; //[0, 0]
    }

    getProperties() {
        return {};
    }

    toJSON(key) {
        var j = {
            type: this.type,
            geometry: { "type": "Point", "coordinates": this.getLonLat() },
            properties: this.getProperties(),
            id: this.getId(),
            locationId: this.locationId
        };
        this.debug('toJSON', j);
        return j;
    }





}

